import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { toggleSwitch, setActiveTab } from '../../../actions';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Icon from '@mdi/react';
import { mdiFormatColorFill, 
        mdiFilter, 
        mdiCog, 
        mdiChartGantt,
        mdiDownload } from '@mdi/js';

import ColorTab from './colorTab.js';
import FilterTab from './filterTab.js';
import SettingTab from './settingTab.js';
import { ToggleActions } from '../../../constants/constants.js';
import ExportTabs from './exportsTab.js';

class TabsMenu extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tabIndex: 0,
            itemsTabIndex: 5
        }
    }

    handleTabChange = (event, newValue) => {
        if (newValue === this.state.itemsTabIndex) {
            this.props.toggleSwitch(ToggleActions.ITEMS);
        } else {     
            this.setState({ tabIndex: newValue });
            this.props.setActiveTab(newValue)
        }
    }

    render() {
        const buttonSize = 0.75;
        const showExportTab = this.props.userRole.project_dashboard || this.props.userRole.reports
        const showItemTab = this.props.userRole.view_gantt 
        && this.props.itemsData !== 'unset' 
        && this.props.itemsProgress !== 'unset'
        && Object.keys(this.props.qualityProgress).length > 0;
        return(
            <div className='menu-tabs-container mt-2'>
                <Tabs
                    value={this.props.activeTab}
                    onChange={this.handleTabChange}
                    textColor='primary'
                    >
                    <Tab icon={ <Icon path={ mdiFormatColorFill } size={buttonSize} />}/>
                    <Tab icon={ <Icon path={ mdiFilter } size={buttonSize} />}/>
                    <Tab icon={ <Icon path={ mdiCog } size={buttonSize} />}/>
                    
                    { showExportTab ?
                        <Tab hidden={this.props.activeTab == 4} icon={ <Icon path={ mdiDownload } size={buttonSize} />}/>
                        : <Tab hidden/>}
                    {/* It is needed because of the popUpMenu activeTab changes */}
                    { showExportTab ?
                        <Tab hidden={this.props.activeTab != 4} icon={ <Icon path={ mdiDownload } size={buttonSize} />}/>
                        : <Tab hidden/>}
                    { showItemTab ? 
                        <Tab icon={ <Icon path={ mdiChartGantt } size={buttonSize} />}/>
                        : <Tab hidden/>}
                </Tabs>
                <ColorTab index={0} tabIndex={this.props.activeTab}/>
                <FilterTab index={1} tabIndex={this.props.activeTab}/>
                <SettingTab index={2} tabIndex={this.props.activeTab}/>
                <ExportTabs index={[3,4]} tabIndex={this.props.activeTab}/>
            </div>
        );
    } 
}

function mapStateToProps( state ){
    return {
        userRole  : state.userRole,
        itemsData : state.itemsData,
        itemsProgress   : state.itemsProgress,
        qualityProgress : state.qualityProgress,
        activeTab: state.activeTab
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({ 
        toggleSwitch : toggleSwitch,
        setActiveTab: setActiveTab
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(TabsMenu);